import { render, staticRenderFns } from "./LegalContents.vue?vue&type=template&id=530d5c74&"
import script from "./LegalContents.vue?vue&type=script&lang=ts&"
export * from "./LegalContents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports